<template>
    <div>
        <!-- BOTAO NOVO PERIODO -->
        <v-row>
            <v-spacer></v-spacer>
            <modal-gdb :code="modal_code"
                :dialog-width="$vuetify.display.mdAndUp? '50%': '100%'"
                toolbar-title="Períodos" 
                :ref="modal_code">
                <template v-slot:activate-slot>
                    <slot name="modal-activate">
                        Períodos
                    </slot>
                </template>
                <template v-slot:body>
                    <h2 class="mb-3">Período</h2>
                    <v-text-field v-model="object.descricao"
                        label="Descrição">
                    </v-text-field>
                    <v-text-field v-model="object.inicio"
                        label="Início"
                        type="date">
                    </v-text-field>
                    <v-text-field v-model="object.fim"
                        label="Fim"
                        type="date">
                    </v-text-field>
                </template>
                <template #actions>
                    <v-btn color="primary" variant="flat" @click="savePeriodo(object)">Salvar</v-btn>
                </template>
            </modal-gdb>
        </v-row>
    </div>
</template>

<script>
import PeriodoFormValidation from './../../../validations/forms/rh/formPeriodo'
const formvalidation = new PeriodoFormValidation()
export default {
    name:'FormPeriodoComponent',
    props: {
        item: {
            required:false,
            default: { descricao: '', inicio: '', fim: '' }
        }
    },
    data: (v) => ({
        object: v.item,
        modal_code: 'modal_rh_periodo',
        a_object: {
            descricao: 'SET/2023',
            inicio: '2023-09-01',
            fim: '2023-09-30'
        }
    }),
    methods: {
        validateForm(data){
            const valida = formvalidation.validate(data)
            return valida
        },
        savePeriodo(data){
            if (!this.validateForm(data)) return

            if(!data.id){
                this.createPeriodo(data)
            } else {
                this.updatePeriodo(data)
            }
        },
        async createPeriodo(data){
            const created = await this.$store.dispatch('CreateRHPeriodo', data)
            if (created) {
                this.$emit('on-created', true)
                this.closeFormModal()
            }
        },
        async updatePeriodo(data){
            const updated = await this.$store.dispatch('UpdateRHPeriodo', data)
            if (updated) {
                this.$emit('on-updated', true)
                this.closeFormModal()
            }
        },
        closeFormModal(){
            this.$refs[this.modal_code].dialog = false
        },
        async deletePeriodo(data){
            const conf = confirm('Tem certeza que deseja remover o período "'+ data.descricao + '"?')
            if (!conf) return

            const deleted = await this.$store.dispatch('DeleteRHPeriodo', data)
            if(deleted){
                this.$emit('on-deleted', true)
                this.closeFormModal()
            }
        }
    },
    mounted() {
    }
}
</script>